// FETCH ALL PRICE_MAPPING
export const FETCH_PRICE_MAPPING_REQUEST = 'FETCH_PRICE_MAPPING_REQUEST';
export const FETCH_PRICE_MAPPING_SUCCESS = 'FETCH_PRICE_MAPPING_SUCCESS';
export const FETCH_PRICE_MAPPING_FAILURE = 'FETCH_PRICE_MAPPING_FAILURE';

// FETCH ALL CURRENCY
export const FETCH_CURRENCY_REQUEST = 'FETCH_CURRENCY_REQUEST';
export const FETCH_CURRENCY_SUCCESS = 'FETCH_CURRENCY_SUCCESS';
export const FETCH_CURRENCY_FAILURE = 'FETCH_CURRENCY_FAILURE';

// CREATE PRICE_MAPPING
export const CREATE_PRICE_MAPPING_REQUEST = 'CREATE_PRICE_MAPPING_REQUEST';
export const CREATE_PRICE_MAPPING_SUCCESS = 'CREATE_PRICE_MAPPING_SUCCESS';
export const CREATE_PRICE_MAPPING_FAILURE = 'CREATE_PRICE_MAPPING_FAILURE';

// UPDATE PRICE_MAPPING
export const UPDATE_PRICE_MAPPING_REQUEST = 'UPDATE_PRICE_MAPPING_REQUEST';
export const UPDATE_PRICE_MAPPING_SUCCESS = 'UPDATE_PRICE_MAPPING_SUCCESS';
export const UPDATE_PRICE_MAPPING_FAILURE = 'UPDATE_PRICE_MAPPING_FAILURE';

// FETCH SINGLE STATE
export const FETCH_SINGLE_PRICE_MAPPING_REQUEST = 'FETCH_SINGLE_PRICE_MAPPING_REQUEST';
export const FETCH_SINGLE_PRICE_MAPPING_SUCCESS = 'FETCH_SINGLE_PRICE_MAPPING_SUCCESS';
export const FETCH_SINGLE_PRICE_MAPPING_FAILURE = 'FETCH_SINGLE_PRICE_MAPPING_FAILURE';

// DELETE PRICE_MAPPING
export const DELETE_PRICE_MAPPING_REQUEST = 'DELETE_PRICE_MAPPING_REQUEST';
export const DELETE_PRICE_MAPPING_SUCCESS = 'DELETE_PRICE_MAPPING_SUCCESS';
export const DELETE_PRICE_MAPPING_FAILURE = 'DELETE_PRICE_MAPPING_FAILURE';

export const RESET_PRICE_MAPPING_INFO = 'RESET_PRICE_MAPPING_INFO';

export const CREATE_PRICE_MAPPING_FORM = 'CREATE_PRICE_MAPPING_FORM';

export const UPDATE_PRICE_MAPPING_FORM = 'UPDATE_PRICE_MAPPING_FORM';
